module.exports = __webpack_public_path__ + "static/media/apply.c5120c6b.svg";